import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { TmmsaisineSaisineModule } from './saisine/saisine.module';
import { TmmsaisineLicenceSchoolModule } from './licence-school/licence-school.module';
import { TmmsaisineMasterModule } from './master/master.module';
import { TmmsaisineMasterProposalModule} from './master-proposal/master-proposal.module';

/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */

@NgModule({
    imports: [
        TmmsaisineSaisineModule,
        TmmsaisineLicenceSchoolModule,
        TmmsaisineMasterModule,
        TmmsaisineMasterProposalModule,
        /* jhipster-needle-add-entity-module - JHipster will add entity modules here */
    ],
    declarations: [
    ],
    entryComponents: [],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TmmsaisineEntityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity.module.ts